import FirestoreService from "../firestore";
import { InformationSource } from "@/types/information-source/information-source.types";

interface FirestoreResponse {
  entity?: string;
  [key: string]: any;
}

export const infoSourceService = {
  create: async (body: Omit<InformationSource, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
    const result = (await FirestoreService.request(
      "create-infoSource",
      body,
      "setup_infoSources",
      issuedBy
    )) as FirestoreResponse;

    const documentId = result?.entity;
    if (!documentId) {
      throw new Error("Failed to create information source: No ID returned");
    }
    return documentId;
  },

  edit: async (id: string, body: Partial<InformationSource>, issuedBy?: string) => {
    const result = (await FirestoreService.request(
      "edit-infoSource",
      { id, ...body },
      "setup_infoSources",
      issuedBy
    )) as FirestoreResponse;
    return result;
  },

  archive: async (documentId: string, issuedBy?: string) => {
    return FirestoreService.request(
      "archive-infoSource",
      { documentId },
      "setup_infoSources",
      issuedBy
    ) as Promise<FirestoreResponse>;
  },

  restore: async (documentId: string, issuedBy?: string) => {
    return FirestoreService.request(
      "restore-infoSource",
      { documentId },
      "setup_infoSources",
      issuedBy
    ) as Promise<FirestoreResponse>;
  },
};
